var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSky(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffcb05;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10,15c-2.8,0-5-2.2-5-5s2.2-5,5-5,5,2.2,5,5-2.2,5-5,5Zm0-8c-1.7,0-3,1.3-3,3s1.3,3,3,3,3-1.3,3-3-1.3-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11,4h-2V1c0-.6.4-1,1-1h0c.6,0,1,.4,1,1v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10,20h0c-.6,0-1-.4-1-1v-3h2v3c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.9,6.5l-1.4-1.4,2.1-2.1c.4-.4,1-.4,1.4,0h0c.4.4.4,1,0,1.4l-2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.9,17.1h0c-.4-.4-.4-1,0-1.4l2.1-2.1,1.4,1.4-2.1,2.1c-.3.4-1,.4-1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.1,6.5l-2.2-2.2c-.4-.4-.4-1,0-1.4h0c.4-.4,1-.4,1.4,0l2.1,2.1-1.3,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.7,17.1l-2.1-2.1,1.4-1.4,2.1,2.1c.4.4.4,1,0,1.4h0c-.4.4-1.1.4-1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4,11H1c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h3v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19,11h-3v-2h3c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSky);
export default __webpack_public_path__ + "static/media/clear_sky.e575cbb92c852d20f7d2848f9cb9ae9b.svg";
export { ForwardRef as ReactComponent };